import React, { Component } from 'react';
import Downshift from 'downshift';
import { createCoinThumbUrl } from '../Shared/utils';

class CoinBrowser extends Component {
  state = {
    coinList: [],
    headCoin: null,
    menuIsOpen: true,
  }

  onChange = ({ pageLink }) => {
    this.toggleMenu();

    window.location.href = pageLink;
  }

  toggleMenu = (event) => {
    const isCTATarget = event
      && event.target
      && event.target.classList.contains('luna-button--action');

    if (isCTATarget) {
      return;
    }

    this.setState(prevState => ({
      isMenuOpen: !prevState.isMenuOpen,
    }))
  }

  createThumbUrl = symbol => createCoinThumbUrl(this.props.cryptoAssetsUrl, symbol);

  renderHeadCoin = ({ symbol, pageLink, name }, isOpen) => (
    <div className="coin-browser__masterRow" onClick={this.toggleMenu}>
      <img loading="lazy" src={this.createThumbUrl(symbol)} alt="" />
      <strong>{name}</strong>
      <small>
        {symbol}
        <svg className="luna-icon" aria-hidden="true">
          <use xlinkHref={`#chevron-${isOpen ? 'up' : 'down'}`}></use>
        </svg>
      </small>
      <a className="luna-button luna-button--action" href={pageLink}>
        <span>Go</span>
      </a>
    </div>
  );

  renderDropdownMenu = ({
    getInputProps,
    getItemProps,
    isOpen,
    inputValue,
    highlightedIndex,
  }) => {
    const {
      coinList: items,
      headCoin,
    } = this.state;

    const renderMenuItem = this.renderDropdownMenuItem({
      highlightedIndex, getItemProps
    });

    const selectMatchingMenuItem = this.filterMenuItems(inputValue);

    return (
      <div className="coin-browser__menu">
        {headCoin && this.renderHeadCoin(headCoin, isOpen)}
        {isOpen && (
          <div className="coin-browser__search">
            <input className="luna-input" {...getInputProps({ placeholder: 'Search for a coin' }) } />
            <div className="coin-browser__list">
              {items
                .filter(selectMatchingMenuItem)
                .map(renderMenuItem)}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderDropdownMenuItem = ({
    highlightedIndex,
    getItemProps,
  }) => (item, index) => (
    <div
      {...getItemProps({ item }) }
      key={item.symbol}
      className={highlightedIndex === index ? 'is-selected' : ''}
    >
      <img loading="lazy" src={this.createThumbUrl(item.symbol)} alt="" />
      <strong>{item.name}</strong>
      <small>
        {item.symbol}
        <svg className="luna-icon" aria-hidden="true">
          <use xlinkHref="#chevron-right"></use>
        </svg>
      </small>
    </div>
  );

  filterMenuItems = inputValue => i =>
    !inputValue
    || (!!i.name &&
      i.name.toLowerCase().includes(inputValue.toLowerCase()))
    || (!!i.symbol &&
      i.symbol.toLowerCase().includes(inputValue.toLowerCase()))


  componentDidMount() {
    const coinList = Object.values(this.props.coinDictionary);
    const headCoin = coinList.find(coin => coin.symbol === 'BTC');
    const orderedCoinList = coinList
      .filter(coin => coin !== headCoin)
      .sort((a, b) => a && b && a.name.localeCompare(b.name));

    this.setState({
      coinList: orderedCoinList,
      headCoin,
    });
  }

  render() {
    const { isMenuOpen } = this.state;
    return (
      <Downshift
        onSelect={this.onChange}
        isOpen={isMenuOpen}
        onOuterClick={this.toggleMenu}
        itemToString={i => i && i.name}
        render={this.renderDropdownMenu}
      />
    );
  }
}

export default CoinBrowser;



// WEBPACK FOOTER //
// ./src/CoinBrowser/index.js